import feathers from '@feathersjs/feathers';
import socketio from '@feathersjs/socketio-client';
import auth from '@feathersjs/authentication-client';
import io from 'socket.io-client';

const host = process.env.NODE_ENV === 'production' ? '/' : 'http://localhost:3030';
// const host = 'https://coeus.uwa.dental';

const socket = io(host);

const feathersClient = feathers()
  .configure(socketio(socket))
  .configure(auth({ storage: window.localStorage }));

export default feathersClient;
